module.exports = __webpack_public_path__ + "static/media/data_dup.205ff66c.png";